import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import { RequestDetailsVTO, RequestLogResultSet, RequestLogFilters, AcceptPharmacyVTO } from './request.model';
import { EligibleEventResultSet } from './workflow.model';
import { ErrorVTO } from './pharmacy.model';
import { AuthService } from '../auth-service';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.pharmacyMgtApiUrl;
  private WORKFLOW_API = environment.workflowApiUrl;

  getPharmacyRequest(pharmacyId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<RequestDetailsVTO>(`${this.WORKFLOW_API}/pharmacies/${pharmacyId}/request`, { headers }).pipe(
      tap(() => console.log('Pharmacy request retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getPharmacyRequestLogs(pharmacyId: number, filters?: RequestLogFilters) {
    let params = new HttpParams();
    if (filters) {
      if (filters.pageNum != undefined && filters.pageNum != null) {
        params = params.set('pageNum', filters.pageNum.toString());
      }
      if (filters.pageSize != undefined && filters.pageSize != null) {
        params = params.set('pageSize', filters.pageSize.toString());
      }
      if (filters.pageOffset != undefined && filters.pageOffset != null) {
        params = params.set('pageOffset', filters.pageOffset.toString());
      }
    }

    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http
      .get<RequestLogResultSet>(`${this.WORKFLOW_API}/pharmacies/${pharmacyId}/request/logs`, { params, headers })
      .pipe(
        tap(() => console.log('Pharmacy request logs retrieved successfully')),
        catchError(this.handleError),
      );
  }

  getRequestLogs(requestId: number, filters?: RequestLogFilters) {
    let params = new HttpParams();
    if (filters) {
      if (filters.pageNum != undefined && filters.pageNum != null) {
        params = params.set('pageNum', filters.pageNum.toString());
      }
      if (filters.pageSize != undefined && filters.pageSize != null) {
        params = params.set('pageSize', filters.pageSize.toString());
      }
      if (filters.pageOffset != undefined && filters.pageOffset != null) {
        params = params.set('pageOffset', filters.pageOffset.toString());
      }
    }

    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http
      .get<RequestLogResultSet>(`${this.WORKFLOW_API}/pharmacies/${requestId}/request/logs`, { params, headers })
      .pipe(
        tap(() => console.log('Request logs retrieved successfully')),
        catchError(this.handleError),
      );
  }

  getRequestEligibleEvents(requestId: number) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http
      .get<EligibleEventResultSet>(`${this.WORKFLOW_API}/requests/${requestId}/events/eligible`, { headers })
      .pipe(
        tap(() => console.log('Request eligible events retrieved successfully')),
        catchError(this.handleError),
      );
  }

  private handleError(error: HttpErrorResponse) {
    const apiError: ErrorVTO = error.error;
    console.error('An API error occurred:', apiError);
    return throwError(() => apiError);
  }
}
